<style src="./Numberbox.scss" lang="scss" scoped></style>
<template lang="html">
  <label
    class="cp1-textbox"
    :class="{'valid-fail': !isValid}">

    <label class="label">
      <span class="caption">{{ label }}</span>
      <input
        type="text"
        class="cp1-small-textbox textbox"
        v-model="inputValue"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :disabled="disabled"
        v-debounce="debounce"
        @debounced="emitDebounce"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
        @keyup="ev => $emit('keyup', ev)"
        @keydown.enter="ev => $emit('keyenter', ev)"
        @keydown.esc="ev => $emit('keyesc', ev)" />
    </label>
  </label>
</template>

<script>
import {DebounceDirective} from '../helpers/debounce/Debounce'
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin.js'
import { DecimalNumber } from '@/components/primitives/helpers/filters'

export default {
  name: 'Numberbox',
  mixins: [
    ValidationMixin
  ],
  directives: {
    debounce: DebounceDirective
  },
  props: {
    label: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    autofocus: {
      default: false
    },
    debounce: {
      default: null
    },
    disabled: {
      default: false
    },
    precision: {
      default: 2
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  watch: {
    precision (p) {
      // this.refreshValues()
    },
    inputValue (pValue, pOldValue) {
      if (isNaN(Number(pValue))) {
        // this.$emit('input', 0)
      }
      if (pValue !== pOldValue) this.$emit('input', this.toNumberUS(pValue))
    },
    value (newValue, oldValue) {
      this.refreshValues(newValue)
    }
  },
  mounted () {
    this.refreshValues()
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    emitDebounce () {
      this.$emit('debounce', this.inputValue)
    },
    refreshValues (value) {
      let v = 0
      if (!isNaN(Number(value))) {
        v = value
        this.inputValue = DecimalNumber(v, this.precision, this.precision, '0,00')
      }
    },
    toNumberUS (pValue) {
      return Number(pValue.toString().replace(/\./g, '').replace(',', '.'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/cp1-numberbox/Numberbox.vue